module.exports = __webpack_public_path__ + "static/scrum-space-02-97b087921393367fded767d6f89a5146.jpg";